import React from 'react';
import PropTypes from 'prop-types';

function IconSaveAs({ color = '#88898B', size = 16, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4063_47217)">
        <path d="M10.6538 4.61536H12.0962C12.4787 4.61536 12.8455 4.76731 13.116 5.0378C13.3865 5.30828 13.5385 5.67514 13.5385 6.05766V13.5577C13.5385 13.9402 13.3865 14.307 13.116 14.5775C12.8455 14.848 12.4787 15 12.0962 15H3.44231C3.05978 15 2.69293 14.848 2.42244 14.5775C2.15196 14.307 2 13.9402 2 13.5577V6.05766C2 5.67514 2.15196 5.30828 2.42244 5.0378C2.69293 4.76731 3.05978 4.61536 3.44231 4.61536H4.88462" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4.88464 8.07692L7.76926 10.9615L10.6539 8.07692M7.76926 0V10.3846" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_4063_47217">
          <rect width="16" height="16" fill={color}/>
        </clipPath>
      </defs>
    </svg>
  )
}

IconSaveAs.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconSaveAs;
